export const workerPaySurveyQueryKeys = {
  workerPaySurveys: (userId: string) => ["workerPaySurveys", userId] as const,
};
